/// <amd-module name="Widgets/SprintBurndownConfig/Pickers/OpStoreTeamsPickerHelper" />
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { WebApiTeam } from "Tfs/Platform/Contracts/Core";
import { IVssPageContext } from "VSS/Platform/Context";
import { IListBoxItem } from "VSSUI/ListBox";
import { convertToListBoxItems, OpStoreTeamsQuery } from "Widgets/Configs/Common/OpStoreTeamsQuery";

export async function getTeamListItems(pageContext: IVssPageContext, projectId: string): Promise<IListBoxItem<WebApiTeam>[]> {
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const teams = await queryCache.getCacheableQueryResult(OpStoreTeamsQuery.onProject(projectId));
    return convertToListBoxItems(teams);
}
